import { getLoginErpByPath } from '@/services/erp'
import { getToken } from '@/utils/token'
import { push, LOGIN_URL } from './jump'
import { message as $message } from 'antd'

export const goToErp = async (routeUrl: string) => {
    const access_token = getToken()
    if (access_token) {
        const res = await getLoginErpByPath({
            routeUrl,
        })

        const { message, data, success } = res || {}
        if (success) {
            return data
        } else {
            $message.error(message)
        }
    } else {
        push(
            {
                url: LOGIN_URL,
                params: {
                    redirect: location.href,
                },
            },
            { decode: true },
        )
    }
}

export const getUrlFromLocation = (location: any) => {
    const { query } = location || {}
    const { url } = query || {}
    return url
}
